import Sidebar from '@/components/Sidebar';
import SubscriptionExpiredOverlay from '@/components/subscription/SubscriptionExpiredOverlay';
import { FunctionComponent, PropsWithChildren } from 'react';
import { Outlet } from 'react-router-dom';

interface iLayoutProps extends PropsWithChildren {}

const Layout: FunctionComponent<iLayoutProps> = ({ children }) => {
  return (
    <div className='flex h-screen'>
      <Sidebar />
      <div className='flex-1 flex flex-col overflow-x-hidden relative'>
        <SubscriptionExpiredOverlay />
        <Outlet />
        {children}
      </div>
    </div>
  );
};

export default Layout;
